module.exports = __webpack_public_path__ + "assets/images/bt-loading.gif?v=c9d38d73";